//#region Styles
import {
    Container, 
    StyledRadio 
} from "./styles";
import { 
    Column,
    Row } from "components/styles";
//#endregion
// #region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
// #endregion

export const CustomRadio = ({
    label, icon, 
    onChange, 
    checked = false,
    disabled,
    error,
    fontSizeLabel
}) => {
    const getClassName = () => {
        const classList = [];
        disabled && classList.push("disabled");
        error && classList.push("error");
        return classList.join(" ");
    }
    return (
        <Container className={getClassName()}
            fontSizeLabel={fontSizeLabel} 
            onClick={onChange}>
            <StyledRadio 
                type="radio"
                disabled={disabled}
                onChange={onChange}
                checked={checked}
                className={getClassName()}/>
            <label onClick={onChange}>
                {label}
            </label>
            {icon && icon}
        </Container>
    );
}

const getFlow = {
    "row": Row,
    "column": Column
};

const HandlerRadio = ({
    value, onChange, 
    disabled, radiosProps = [],
    direction = "row",
    marginTop, marginBottom,
    gap, width = "100%", 
    minWidth, error = false, errorText
}) => {
    const Flow = getFlow[direction];
    return (
        <Column 
            width={width}
            minWidth={minWidth}>
            <Flow 
                justifyContent="flex-start" 
                gap={gap} width={width}
                marginTop={marginTop} marginBottom={marginBottom}>
                {radiosProps.map((props, idx) => {
                    return (
                        <CustomRadio  
                            key={idx} 
                            disabled={disabled}
                            label={props.label}
                            icon={props.icon}
                            onChange={() => onChange && onChange(props.value, props.label)}
                            checked={value === props.value}
                            error={error}/>
                    );
                })}
            </Flow>
            <ErrorMessage 
                text={errorText}
                error={error}/>
        </Column>
    );
}

export default HandlerRadio;